import { AchievementInfo } from "./AchievementInfoTypes";

// Total achievements
import {
  Achievement_Total_Bricks_100,
  Achievement_Total_Bricks_1000,
  Achievement_Total_Bricks_10000,
  Achievement_Total_Bricks_2500000,
  Achievement_Total_Bricks_100000,
  Achievement_Total_Bricks_50000000,
  Achievement_Total_Bricks_100000000,
  Achievement_Total_Bricks_250000000,
  Achievement_Total_Sets_10,
  Achievement_Total_Sets_50,
  Achievement_Total_Sets_10000,
  Achievement_Total_Sets_15000,
  Achievement_Total_Sets_20000,
  Achievement_Total_Sets_30000,
  Achievement_Total_Sets_40000,
  Achievement_Total_Sets_50000,
} from "./TotalAchievements";

// Brick achievements
import {
  Achievement_Brick_3005_100,
  Achievement_Brick_3005_1000,
  Achievement_Brick_3005_10000,
  Achievement_Brick_3005_100000,
  Achievement_Brick_3005_1000000,
  Achievement_Brick_3004_100,
  Achievement_Brick_3004_1000,
  Achievement_Brick_3004_10000,
  Achievement_Brick_3004_100000,
  Achievement_Brick_3004_1000000,
  Achievement_Brick_3010_100,
  Achievement_Brick_3010_1000,
  Achievement_Brick_3010_10000,
  Achievement_Brick_3010_100000,
  Achievement_Brick_3010_1000000,
  Achievement_Brick_3003_100,
  Achievement_Brick_3003_1000,
  Achievement_Brick_3003_10000,
  Achievement_Brick_3003_100000,
  Achievement_Brick_3003_1000000,
  Achievement_Brick_3001_100,
  Achievement_Brick_3001_1000,
  Achievement_Brick_3001_10000,
  Achievement_Brick_3001_100000,
  Achievement_Brick_3001_1000000,
  Achievement_Brick_3024_100,
  Achievement_Brick_3024_1000,
  Achievement_Brick_3024_10000,
  Achievement_Brick_3024_100000,
  Achievement_Brick_3024_1000000,
  Achievement_Brick_3023_100,
  Achievement_Brick_3023_1000,
  Achievement_Brick_3023_10000,
  Achievement_Brick_3023_100000,
  Achievement_Brick_3023_1000000,
  Achievement_Brick_3710_100,
  Achievement_Brick_3710_1000,
  Achievement_Brick_3710_10000,
  Achievement_Brick_3710_100000,
  Achievement_Brick_3710_1000000,
  Achievement_Brick_3022_100,
  Achievement_Brick_3022_1000,
  Achievement_Brick_3022_10000,
  Achievement_Brick_3022_100000,
  Achievement_Brick_3022_1000000,
  Achievement_Brick_3020_100,
  Achievement_Brick_3020_1000,
  Achievement_Brick_3020_10000,
  Achievement_Brick_3020_100000,
  Achievement_Brick_3020_1000000,
  Achievement_Brick_54200_100,
  Achievement_Brick_54200_1000,
  Achievement_Brick_54200_10000,
  Achievement_Brick_54200_50000,
  Achievement_Brick_3040_100,
  Achievement_Brick_3040_1000,
  Achievement_Brick_3040_10000,
  Achievement_Brick_3040_50000,
  Achievement_Brick_4286_100,
  Achievement_Brick_4286_1000,
  Achievement_Brick_4286_10000,
  Achievement_Brick_4286_50000,
  Achievement_Brick_60477_100,
  Achievement_Brick_60477_1000,
  Achievement_Brick_60477_10000,
  Achievement_Brick_60477_50000,
  Achievement_Brick_3039_100,
  Achievement_Brick_3039_1000,
  Achievement_Brick_3039_10000,
  Achievement_Brick_3039_50000,
  Achievement_Brick_30363_100,
  Achievement_Brick_30363_1000,
  Achievement_Brick_30363_10000,
  Achievement_Brick_30363_50000,
  Achievement_Brick_3660_100,
  Achievement_Brick_3660_1000,
  Achievement_Brick_3660_10000,
  Achievement_Brick_3660_50000,
  Achievement_Brick_2752_100,
  Achievement_Brick_2752_1000,
  Achievement_Brick_2752_10000,
  Achievement_Brick_2752_50000,
  Achievement_Brick_30390_100,
  Achievement_Brick_30390_1000,
  Achievement_Brick_30390_10000,
  Achievement_Brick_30390_50000,
  Achievement_Brick_6091_100,
  Achievement_Brick_6091_1000,
  Achievement_Brick_6091_10000,
  Achievement_Brick_6091_50000,
  Achievement_Brick_4349_100,
  Achievement_Brick_4349_1000,
  Achievement_Brick_4349_10000,
  Achievement_Brick_4349_50000,
  Achievement_Brick_30162_100,
  Achievement_Brick_30162_1000,
  Achievement_Brick_30162_10000,
  Achievement_Brick_30162_50000,
  Achievement_Brick_30228_100,
  Achievement_Brick_30228_1000,
  Achievement_Brick_30228_10000,
  Achievement_Brick_30228_50000,
  Achievement_Brick_6246a_100,
  Achievement_Brick_6246a_1000,
  Achievement_Brick_6246a_10000,
  Achievement_Brick_6246a_50000,
  Achievement_Brick_30148_100,
  Achievement_Brick_30148_1000,
  Achievement_Brick_30148_10000,
  Achievement_Brick_30148_50000,
  Achievement_Brick_93106_100,
  Achievement_Brick_93106_1000,
  Achievement_Brick_93106_10000,
  Achievement_Brick_93106_50000,
  Achievement_Brick_4449_100,
  Achievement_Brick_4449_1000,
  Achievement_Brick_4449_10000,
  Achievement_Brick_4449_50000,
  Achievement_Brick_30304_100,
  Achievement_Brick_30304_1000,
  Achievement_Brick_30304_10000,
  Achievement_Brick_30304_50000,
  Achievement_Brick_3962a_100,
  Achievement_Brick_3962a_1000,
  Achievement_Brick_3962a_10000,
  Achievement_Brick_3962a_50000,
  Achievement_Brick_3835_100,
  Achievement_Brick_3835_1000,
  Achievement_Brick_3835_10000,
  Achievement_Brick_3835_50000,
  Achievement_Brick_54271_100,
  Achievement_Brick_54271_1000,
  Achievement_Brick_54271_10000,
  Achievement_Brick_54271_50000,
  Achievement_Brick_42042_100,
  Achievement_Brick_42042_1000,
  Achievement_Brick_42042_10000,
  Achievement_Brick_42042_50000,
  Achievement_Brick_32553_100,
  Achievement_Brick_32553_1000,
  Achievement_Brick_32553_10000,
  Achievement_Brick_32553_50000,
  Achievement_Brick_47298_100,
  Achievement_Brick_47298_1000,
  Achievement_Brick_47298_10000,
  Achievement_Brick_47298_50000,
  Achievement_Brick_41671_100,
  Achievement_Brick_41671_1000,
  Achievement_Brick_41671_10000,
  Achievement_Brick_41671_50000,
  Achievement_Brick_43558_100,
  Achievement_Brick_43558_1000,
  Achievement_Brick_43558_10000,
  Achievement_Brick_43558_50000,
  Achievement_Brick_32506_100,
  Achievement_Brick_32506_1000,
  Achievement_Brick_32506_10000,
  Achievement_Brick_32506_50000,
  Achievement_Brick_42760_100,
  Achievement_Brick_42760_1000,
  Achievement_Brick_42760_10000,
  Achievement_Brick_42760_50000,
  Achievement_Brick_42074_100,
  Achievement_Brick_42074_1000,
  Achievement_Brick_42074_10000,
  Achievement_Brick_42074_50000,
  Achievement_Brick_x346_100,
  Achievement_Brick_x346_1000,
  Achievement_Brick_x346_10000,
  Achievement_Brick_x346_50000,
  Achievement_Brick_30173_100,
  Achievement_Brick_30173_1000,
  Achievement_Brick_30173_10000,
  Achievement_Brick_30173_50000,
  Achievement_Brick_76764_100,
  Achievement_Brick_76764_1000,
  Achievement_Brick_76764_10000,
  Achievement_Brick_76764_50000,
  Achievement_Brick_64644_100,
  Achievement_Brick_64644_1000,
  Achievement_Brick_64644_10000,
  Achievement_Brick_64644_50000,
  Achievement_Brick_6246f_100,
  Achievement_Brick_6246f_1000,
  Achievement_Brick_6246f_10000,
  Achievement_Brick_6246f_50000,
  Achievement_Brick_55297_100,
  Achievement_Brick_55297_1000,
  Achievement_Brick_55297_10000,
  Achievement_Brick_55297_50000,
  Achievement_Brick_36752a_100,
  Achievement_Brick_36752a_1000,
  Achievement_Brick_36752a_10000,
  Achievement_Brick_36752a_50000,
  Achievement_Brick_30229_100,
  Achievement_Brick_30229_1000,
  Achievement_Brick_30229_10000,
  Achievement_Brick_30229_50000,
  Achievement_Brick_30194_100,
  Achievement_Brick_30194_1000,
  Achievement_Brick_30194_10000,
  Achievement_Brick_30194_50000,
  Achievement_Brick_64567_100,
  Achievement_Brick_64567_1000,
  Achievement_Brick_64567_10000,
  Achievement_Brick_64567_50000,
  Achievement_Brick_30035_100,
  Achievement_Brick_30035_1000,
  Achievement_Brick_30035_10000,
  Achievement_Brick_30035_50000,
  Achievement_Brick_4493c01pb02_100,
  Achievement_Brick_4493c01pb02_1000,
  Achievement_Brick_4493c01pb02_10000,
  Achievement_Brick_4493c01pb02_50000,
  Achievement_Brick_6086_100,
  Achievement_Brick_6086_1000,
  Achievement_Brick_6086_10000,
  Achievement_Brick_6086_50000,
  Achievement_Brick_48812_100,
  Achievement_Brick_48812_1000,
  Achievement_Brick_48812_10000,
  Achievement_Brick_48812_50000,
  Achievement_Brick_30464_100,
  Achievement_Brick_30464_1000,
  Achievement_Brick_30464_10000,
  Achievement_Brick_30464_50000,
  Achievement_Brick_30103_100,
  Achievement_Brick_30103_1000,
  Achievement_Brick_30103_10000,
  Achievement_Brick_30103_50000,
  Achievement_Brick_30115_100,
  Achievement_Brick_30115_1000,
  Achievement_Brick_30115_10000,
  Achievement_Brick_30115_50000,
  Achievement_Brick_92084_100,
  Achievement_Brick_92084_1000,
  Achievement_Brick_92084_10000,
  Achievement_Brick_92084_50000,
  Achievement_Brick_80674_100,
  Achievement_Brick_80674_1000,
  Achievement_Brick_80674_10000,
  Achievement_Brick_80674_50000,
  Achievement_Brick_33121_100,
  Achievement_Brick_33121_1000,
  Achievement_Brick_33121_10000,
  Achievement_Brick_33121_50000,
  Achievement_Brick_30238_100,
  Achievement_Brick_30238_1000,
  Achievement_Brick_30238_10000,
  Achievement_Brick_30238_50000,
  Achievement_Brick_32567_100,
  Achievement_Brick_32567_1000,
  Achievement_Brick_32567_10000,
  Achievement_Brick_32567_50000,
  Achievement_Brick_32574_100,
  Achievement_Brick_32574_1000,
  Achievement_Brick_32574_10000,
  Achievement_Brick_32574_50000,
  Achievement_Brick_32570_100,
  Achievement_Brick_32570_1000,
  Achievement_Brick_32570_10000,
  Achievement_Brick_32570_50000,
  Achievement_Brick_32575_100,
  Achievement_Brick_32575_1000,
  Achievement_Brick_32575_10000,
  Achievement_Brick_32575_50000,
  Achievement_Brick_32566_100,
  Achievement_Brick_32566_1000,
  Achievement_Brick_32566_10000,
  Achievement_Brick_32566_50000,
  Achievement_Brick_32565_100,
  Achievement_Brick_32565_1000,
  Achievement_Brick_32565_10000,
  Achievement_Brick_32565_50000,
  Achievement_Brick_32571_100,
  Achievement_Brick_32571_1000,
  Achievement_Brick_32571_10000,
  Achievement_Brick_32571_50000,
  Achievement_Brick_32568_100,
  Achievement_Brick_32568_1000,
  Achievement_Brick_32568_10000,
  Achievement_Brick_32568_50000,
  Achievement_Brick_32505_100,
  Achievement_Brick_32505_1000,
  Achievement_Brick_32505_10000,
  Achievement_Brick_32505_50000,
  Achievement_Brick_32573_100,
  Achievement_Brick_32573_1000,
  Achievement_Brick_32573_10000,
  Achievement_Brick_32573_50000,
  Achievement_Brick_4740_100,
  Achievement_Brick_4740_1000,
  Achievement_Brick_4740_10000,
  Achievement_Brick_4740_50000,
  Achievement_Brick_6014b_100,
  Achievement_Brick_6014b_1000,
  Achievement_Brick_6014b_10000,
  Achievement_Brick_6014b_50000,
  Achievement_Brick_3960_100,
  Achievement_Brick_3960_1000,
  Achievement_Brick_3960_10000,
  Achievement_Brick_3960_50000,
  Achievement_Brick_50990b_100,
  Achievement_Brick_50990b_1000,
  Achievement_Brick_50990b_10000,
  Achievement_Brick_50990b_50000,
  Achievement_Brick_2489_100,
  Achievement_Brick_2489_1000,
  Achievement_Brick_2489_10000,
  Achievement_Brick_2489_50000,
  Achievement_Brick_30139_100,
  Achievement_Brick_30139_1000,
  Achievement_Brick_30139_10000,
  Achievement_Brick_30139_50000,
  Achievement_Brick_6222_100,
  Achievement_Brick_6222_1000,
  Achievement_Brick_6222_10000,
  Achievement_Brick_6222_50000,
  Achievement_Brick_41531_100,
  Achievement_Brick_41531_1000,
  Achievement_Brick_41531_10000,
  Achievement_Brick_41531_50000,
  Achievement_Brick_30360_100,
  Achievement_Brick_30360_1000,
  Achievement_Brick_30360_10000,
  Achievement_Brick_30360_50000,
  Achievement_Brick_4285b_100,
  Achievement_Brick_4285b_1000,
  Achievement_Brick_4285b_10000,
  Achievement_Brick_4285b_50000,
  Achievement_Brick_3901_100,
  Achievement_Brick_3901_1000,
  Achievement_Brick_3901_10000,
  Achievement_Brick_3901_50000,
  Achievement_Brick_62696_100,
  Achievement_Brick_62696_1000,
  Achievement_Brick_62696_10000,
  Achievement_Brick_62696_50000,
  Achievement_Brick_53982_100,
  Achievement_Brick_53982_1000,
  Achievement_Brick_53982_10000,
  Achievement_Brick_53982_50000,
  Achievement_Brick_53981_100,
  Achievement_Brick_53981_1000,
  Achievement_Brick_53981_10000,
  Achievement_Brick_53981_50000,
  Achievement_Brick_26139_100,
  Achievement_Brick_26139_1000,
  Achievement_Brick_26139_10000,
  Achievement_Brick_26139_50000,
  Achievement_Brick_42444_100,
  Achievement_Brick_42444_1000,
  Achievement_Brick_42444_10000,
  Achievement_Brick_42444_50000,
  Achievement_Brick_30410_100,
  Achievement_Brick_30410_1000,
  Achievement_Brick_30410_10000,
  Achievement_Brick_30410_50000,
  Achievement_Brick_87991_100,
  Achievement_Brick_87991_1000,
  Achievement_Brick_87991_10000,
  Achievement_Brick_87991_50000,
  Achievement_Brick_13768_100,
  Achievement_Brick_13768_1000,
  Achievement_Brick_13768_10000,
  Achievement_Brick_13768_50000,
  Achievement_Brick_37784_100,
  Achievement_Brick_37784_1000,
  Achievement_Brick_37784_10000,
  Achievement_Brick_37784_50000,
  Achievement_Brick_3713_100,
  Achievement_Brick_3713_1000,
  Achievement_Brick_3713_10000,
  Achievement_Brick_3713_50000,
  Achievement_Brick_3749_100,
  Achievement_Brick_3749_1000,
  Achievement_Brick_3749_10000,
  Achievement_Brick_3749_50000,
  Achievement_Brick_24316_100,
  Achievement_Brick_24316_1000,
  Achievement_Brick_24316_10000,
  Achievement_Brick_24316_50000,
  Achievement_Brick_73230_100,
  Achievement_Brick_73230_1000,
  Achievement_Brick_73230_10000,
  Achievement_Brick_73230_50000,
  Achievement_Brick_3701_100,
  Achievement_Brick_3701_1000,
  Achievement_Brick_3701_10000,
  Achievement_Brick_3701_50000,
  Achievement_Brick_32174_100,
  Achievement_Brick_32174_1000,
  Achievement_Brick_32174_10000,
  Achievement_Brick_32174_50000,
  Achievement_Brick_32034_100,
  Achievement_Brick_32034_1000,
  Achievement_Brick_32034_10000,
  Achievement_Brick_32034_50000,
  Achievement_Brick_3648_100,
  Achievement_Brick_3648_1000,
  Achievement_Brick_3648_10000,
  Achievement_Brick_3648_50000,
  Achievement_Brick_3736_100,
  Achievement_Brick_3736_1000,
  Achievement_Brick_3736_10000,
  Achievement_Brick_3736_50000,
  Achievement_Brick_32168_100,
  Achievement_Brick_32168_1000,
  Achievement_Brick_32168_10000,
  Achievement_Brick_32168_50000,
  Achievement_Brick_3898_100,
  Achievement_Brick_3898_1000,
  Achievement_Brick_3898_10000,
  Achievement_Brick_3898_50000,
  Achievement_Brick_30202_100,
  Achievement_Brick_30202_1000,
  Achievement_Brick_30202_10000,
  Achievement_Brick_30202_50000,
  Achievement_Brick_x164_100,
  Achievement_Brick_x164_1000,
  Achievement_Brick_x164_10000,
  Achievement_Brick_x164_50000,
  Achievement_Brick_3485_100,
  Achievement_Brick_3485_1000,
  Achievement_Brick_3485_10000,
  Achievement_Brick_3485_50000,
  Achievement_Brick_x52_100,
  Achievement_Brick_x52_1000,
  Achievement_Brick_x52_10000,
  Achievement_Brick_x52_50000,
  Achievement_Brick_2528_100,
  Achievement_Brick_2528_1000,
  Achievement_Brick_2528_10000,
  Achievement_Brick_2528_50000,
  Achievement_Brick_3624_100,
  Achievement_Brick_3624_1000,
  Achievement_Brick_3624_10000,
  Achievement_Brick_3624_50000,
  Achievement_Brick_30325_100,
  Achievement_Brick_30325_1000,
  Achievement_Brick_30325_10000,
  Achievement_Brick_30325_50000,
  Achievement_Brick_30167_100,
  Achievement_Brick_30167_1000,
  Achievement_Brick_30167_10000,
  Achievement_Brick_30167_50000,
  Achievement_Brick_30381_100,
  Achievement_Brick_30381_1000,
  Achievement_Brick_30381_10000,
  Achievement_Brick_30381_50000,
} from "./BrickAchievements";

// Brick pack achievements
import {
  Achievement_BrickPack_Sloped_10,
  Achievement_BrickPack_Sloped_50,
  Achievement_BrickPack_Sloped_100,
  Achievement_BrickPack_Minifig_10,
  Achievement_BrickPack_Minifig_50,
  Achievement_BrickPack_Minifig_100,
  Achievement_BrickPack_Bionicles_10,
  Achievement_BrickPack_Bionicles_50,
  Achievement_BrickPack_Bionicles_100,
  Achievement_BrickPack_Animals_10,
  Achievement_BrickPack_Animals_50,
  Achievement_BrickPack_Animals_100,
  Achievement_BrickPack_Minifig2_10,
  Achievement_BrickPack_Minifig2_50,
  Achievement_BrickPack_Minifig2_100,
  Achievement_BrickPack_Bionicles2_10,
  Achievement_BrickPack_Bionicles2_50,
  Achievement_BrickPack_Bionicles2_100,
  Achievement_BrickPack_Circular_10,
  Achievement_BrickPack_Circular_50,
  Achievement_BrickPack_Circular_100,
  Achievement_BrickPack_MinifigHair_10,
  Achievement_BrickPack_MinifigHair_50,
  Achievement_BrickPack_MinifigHair_100,
  Achievement_BrickPack_Technic_10,
  Achievement_BrickPack_Technic_50,
  Achievement_BrickPack_Technic_100,
  Achievement_BrickPack_MinifigHeadgear_10,
  Achievement_BrickPack_MinifigHeadgear_50,
  Achievement_BrickPack_MinifigHeadgear_100,
} from "./BrickPackAchievements";

// Set achievements
import {
  Achievement_Set_6772_1,
  Achievement_Set_6772_10,
  Achievement_Set_8534_1,
  Achievement_Set_8534_10,
  Achievement_Set_4866_1,
  Achievement_Set_4866_10,
  Achievement_Set_4432_1,
  Achievement_Set_4432_10,
  Achievement_Set_7146_1,
  Achievement_Set_7146_10,
  Achievement_Set_71766_1,
  Achievement_Set_71766_10,
  Achievement_Set_21060_1,
  Achievement_Set_21060_10,
  Achievement_Set_10305_1,
  Achievement_Set_10305_10,
  Achievement_Set_10179_1,
  Achievement_Set_10179_10,
  Achievement_Set_10307_1,
  Achievement_Set_10307_10,
} from "./SetAchievements";

export const AchievementInfoTotal: Map<string, AchievementInfo> = new Map([
  // Total achievements
  [Achievement_Total_Bricks_100.id, Achievement_Total_Bricks_100],
  [Achievement_Total_Bricks_1000.id, Achievement_Total_Bricks_1000],
  [Achievement_Total_Bricks_10000.id, Achievement_Total_Bricks_10000],
  [Achievement_Total_Bricks_2500000.id, Achievement_Total_Bricks_2500000],
  [Achievement_Total_Bricks_100000.id, Achievement_Total_Bricks_100000],
  [Achievement_Total_Bricks_50000000.id, Achievement_Total_Bricks_50000000],
  [Achievement_Total_Bricks_100000000.id, Achievement_Total_Bricks_100000000],
  [Achievement_Total_Bricks_250000000.id, Achievement_Total_Bricks_250000000],
  [Achievement_Total_Sets_10.id, Achievement_Total_Sets_10],
  [Achievement_Total_Sets_50.id, Achievement_Total_Sets_50],
  [Achievement_Total_Sets_10000.id, Achievement_Total_Sets_10000],
  [Achievement_Total_Sets_15000.id, Achievement_Total_Sets_15000],
  [Achievement_Total_Sets_20000.id, Achievement_Total_Sets_20000],
  [Achievement_Total_Sets_30000.id, Achievement_Total_Sets_30000],
  [Achievement_Total_Sets_40000.id, Achievement_Total_Sets_40000],
  [Achievement_Total_Sets_50000.id, Achievement_Total_Sets_50000],
  // Brick achievements
  [Achievement_Brick_3005_100.id, Achievement_Brick_3005_100],
  [Achievement_Brick_3005_1000.id, Achievement_Brick_3005_1000],
  [Achievement_Brick_3005_10000.id, Achievement_Brick_3005_10000],
  [Achievement_Brick_3005_100000.id, Achievement_Brick_3005_100000],
  [Achievement_Brick_3005_1000000.id, Achievement_Brick_3005_1000000],
  [Achievement_Brick_3004_100.id, Achievement_Brick_3004_100],
  [Achievement_Brick_3004_1000.id, Achievement_Brick_3004_1000],
  [Achievement_Brick_3004_10000.id, Achievement_Brick_3004_10000],
  [Achievement_Brick_3004_100000.id, Achievement_Brick_3004_100000],
  [Achievement_Brick_3004_1000000.id, Achievement_Brick_3004_1000000],
  [Achievement_Brick_3010_100.id, Achievement_Brick_3010_100],
  [Achievement_Brick_3010_1000.id, Achievement_Brick_3010_1000],
  [Achievement_Brick_3010_10000.id, Achievement_Brick_3010_10000],
  [Achievement_Brick_3010_100000.id, Achievement_Brick_3010_100000],
  [Achievement_Brick_3010_1000000.id, Achievement_Brick_3010_1000000],
  [Achievement_Brick_3003_100.id, Achievement_Brick_3003_100],
  [Achievement_Brick_3003_1000.id, Achievement_Brick_3003_1000],
  [Achievement_Brick_3003_10000.id, Achievement_Brick_3003_10000],
  [Achievement_Brick_3003_100000.id, Achievement_Brick_3003_100000],
  [Achievement_Brick_3003_1000000.id, Achievement_Brick_3003_1000000],
  [Achievement_Brick_3001_100.id, Achievement_Brick_3001_100],
  [Achievement_Brick_3001_1000.id, Achievement_Brick_3001_1000],
  [Achievement_Brick_3001_10000.id, Achievement_Brick_3001_10000],
  [Achievement_Brick_3001_100000.id, Achievement_Brick_3001_100000],
  [Achievement_Brick_3001_1000000.id, Achievement_Brick_3001_1000000],
  [Achievement_Brick_3024_100.id, Achievement_Brick_3024_100],
  [Achievement_Brick_3024_1000.id, Achievement_Brick_3024_1000],
  [Achievement_Brick_3024_10000.id, Achievement_Brick_3024_10000],
  [Achievement_Brick_3024_100000.id, Achievement_Brick_3024_100000],
  [Achievement_Brick_3024_1000000.id, Achievement_Brick_3024_1000000],
  [Achievement_Brick_3023_100.id, Achievement_Brick_3023_100],
  [Achievement_Brick_3023_1000.id, Achievement_Brick_3023_1000],
  [Achievement_Brick_3023_10000.id, Achievement_Brick_3023_10000],
  [Achievement_Brick_3023_100000.id, Achievement_Brick_3023_100000],
  [Achievement_Brick_3023_1000000.id, Achievement_Brick_3023_1000000],
  [Achievement_Brick_3710_100.id, Achievement_Brick_3710_100],
  [Achievement_Brick_3710_1000.id, Achievement_Brick_3710_1000],
  [Achievement_Brick_3710_10000.id, Achievement_Brick_3710_10000],
  [Achievement_Brick_3710_100000.id, Achievement_Brick_3710_100000],
  [Achievement_Brick_3710_1000000.id, Achievement_Brick_3710_1000000],
  [Achievement_Brick_3022_100.id, Achievement_Brick_3022_100],
  [Achievement_Brick_3022_1000.id, Achievement_Brick_3022_1000],
  [Achievement_Brick_3022_10000.id, Achievement_Brick_3022_10000],
  [Achievement_Brick_3022_100000.id, Achievement_Brick_3022_100000],
  [Achievement_Brick_3022_1000000.id, Achievement_Brick_3022_1000000],
  [Achievement_Brick_3020_100.id, Achievement_Brick_3020_100],
  [Achievement_Brick_3020_1000.id, Achievement_Brick_3020_1000],
  [Achievement_Brick_3020_10000.id, Achievement_Brick_3020_10000],
  [Achievement_Brick_3020_100000.id, Achievement_Brick_3020_100000],
  [Achievement_Brick_3020_1000000.id, Achievement_Brick_3020_1000000],
  [Achievement_Brick_54200_100.id, Achievement_Brick_54200_100],
  [Achievement_Brick_54200_1000.id, Achievement_Brick_54200_1000],
  [Achievement_Brick_54200_10000.id, Achievement_Brick_54200_10000],
  [Achievement_Brick_54200_50000.id, Achievement_Brick_54200_50000],
  [Achievement_Brick_3040_100.id, Achievement_Brick_3040_100],
  [Achievement_Brick_3040_1000.id, Achievement_Brick_3040_1000],
  [Achievement_Brick_3040_10000.id, Achievement_Brick_3040_10000],
  [Achievement_Brick_3040_50000.id, Achievement_Brick_3040_50000],
  [Achievement_Brick_4286_100.id, Achievement_Brick_4286_100],
  [Achievement_Brick_4286_1000.id, Achievement_Brick_4286_1000],
  [Achievement_Brick_4286_10000.id, Achievement_Brick_4286_10000],
  [Achievement_Brick_4286_50000.id, Achievement_Brick_4286_50000],
  [Achievement_Brick_60477_100.id, Achievement_Brick_60477_100],
  [Achievement_Brick_60477_1000.id, Achievement_Brick_60477_1000],
  [Achievement_Brick_60477_10000.id, Achievement_Brick_60477_10000],
  [Achievement_Brick_60477_50000.id, Achievement_Brick_60477_50000],
  [Achievement_Brick_3039_100.id, Achievement_Brick_3039_100],
  [Achievement_Brick_3039_1000.id, Achievement_Brick_3039_1000],
  [Achievement_Brick_3039_10000.id, Achievement_Brick_3039_10000],
  [Achievement_Brick_3039_50000.id, Achievement_Brick_3039_50000],
  [Achievement_Brick_30363_100.id, Achievement_Brick_30363_100],
  [Achievement_Brick_30363_1000.id, Achievement_Brick_30363_1000],
  [Achievement_Brick_30363_10000.id, Achievement_Brick_30363_10000],
  [Achievement_Brick_30363_50000.id, Achievement_Brick_30363_50000],
  [Achievement_Brick_3660_100.id, Achievement_Brick_3660_100],
  [Achievement_Brick_3660_1000.id, Achievement_Brick_3660_1000],
  [Achievement_Brick_3660_10000.id, Achievement_Brick_3660_10000],
  [Achievement_Brick_3660_50000.id, Achievement_Brick_3660_50000],
  [Achievement_Brick_2752_100.id, Achievement_Brick_2752_100],
  [Achievement_Brick_2752_1000.id, Achievement_Brick_2752_1000],
  [Achievement_Brick_2752_10000.id, Achievement_Brick_2752_10000],
  [Achievement_Brick_2752_50000.id, Achievement_Brick_2752_50000],
  [Achievement_Brick_30390_100.id, Achievement_Brick_30390_100],
  [Achievement_Brick_30390_1000.id, Achievement_Brick_30390_1000],
  [Achievement_Brick_30390_10000.id, Achievement_Brick_30390_10000],
  [Achievement_Brick_30390_50000.id, Achievement_Brick_30390_50000],
  [Achievement_Brick_6091_100.id, Achievement_Brick_6091_100],
  [Achievement_Brick_6091_1000.id, Achievement_Brick_6091_1000],
  [Achievement_Brick_6091_10000.id, Achievement_Brick_6091_10000],
  [Achievement_Brick_6091_50000.id, Achievement_Brick_6091_50000],
  [Achievement_Brick_4349_100.id, Achievement_Brick_4349_100],
  [Achievement_Brick_4349_1000.id, Achievement_Brick_4349_1000],
  [Achievement_Brick_4349_10000.id, Achievement_Brick_4349_10000],
  [Achievement_Brick_4349_50000.id, Achievement_Brick_4349_50000],
  [Achievement_Brick_30162_100.id, Achievement_Brick_30162_100],
  [Achievement_Brick_30162_1000.id, Achievement_Brick_30162_1000],
  [Achievement_Brick_30162_10000.id, Achievement_Brick_30162_10000],
  [Achievement_Brick_30162_50000.id, Achievement_Brick_30162_50000],
  [Achievement_Brick_30228_100.id, Achievement_Brick_30228_100],
  [Achievement_Brick_30228_1000.id, Achievement_Brick_30228_1000],
  [Achievement_Brick_30228_10000.id, Achievement_Brick_30228_10000],
  [Achievement_Brick_30228_50000.id, Achievement_Brick_30228_50000],
  [Achievement_Brick_6246a_100.id, Achievement_Brick_6246a_100],
  [Achievement_Brick_6246a_1000.id, Achievement_Brick_6246a_1000],
  [Achievement_Brick_6246a_10000.id, Achievement_Brick_6246a_10000],
  [Achievement_Brick_6246a_50000.id, Achievement_Brick_6246a_50000],
  [Achievement_Brick_30148_100.id, Achievement_Brick_30148_100],
  [Achievement_Brick_30148_1000.id, Achievement_Brick_30148_1000],
  [Achievement_Brick_30148_10000.id, Achievement_Brick_30148_10000],
  [Achievement_Brick_30148_50000.id, Achievement_Brick_30148_50000],
  [Achievement_Brick_93106_100.id, Achievement_Brick_93106_100],
  [Achievement_Brick_93106_1000.id, Achievement_Brick_93106_1000],
  [Achievement_Brick_93106_10000.id, Achievement_Brick_93106_10000],
  [Achievement_Brick_93106_50000.id, Achievement_Brick_93106_50000],
  [Achievement_Brick_4449_100.id, Achievement_Brick_4449_100],
  [Achievement_Brick_4449_1000.id, Achievement_Brick_4449_1000],
  [Achievement_Brick_4449_10000.id, Achievement_Brick_4449_10000],
  [Achievement_Brick_4449_50000.id, Achievement_Brick_4449_50000],
  [Achievement_Brick_30304_100.id, Achievement_Brick_30304_100],
  [Achievement_Brick_30304_1000.id, Achievement_Brick_30304_1000],
  [Achievement_Brick_30304_10000.id, Achievement_Brick_30304_10000],
  [Achievement_Brick_30304_50000.id, Achievement_Brick_30304_50000],
  [Achievement_Brick_3962a_100.id, Achievement_Brick_3962a_100],
  [Achievement_Brick_3962a_1000.id, Achievement_Brick_3962a_1000],
  [Achievement_Brick_3962a_10000.id, Achievement_Brick_3962a_10000],
  [Achievement_Brick_3962a_50000.id, Achievement_Brick_3962a_50000],
  [Achievement_Brick_3835_100.id, Achievement_Brick_3835_100],
  [Achievement_Brick_3835_1000.id, Achievement_Brick_3835_1000],
  [Achievement_Brick_3835_10000.id, Achievement_Brick_3835_10000],
  [Achievement_Brick_3835_50000.id, Achievement_Brick_3835_50000],
  [Achievement_Brick_54271_100.id, Achievement_Brick_54271_100],
  [Achievement_Brick_54271_1000.id, Achievement_Brick_54271_1000],
  [Achievement_Brick_54271_10000.id, Achievement_Brick_54271_10000],
  [Achievement_Brick_54271_50000.id, Achievement_Brick_54271_50000],
  [Achievement_Brick_42042_100.id, Achievement_Brick_42042_100],
  [Achievement_Brick_42042_1000.id, Achievement_Brick_42042_1000],
  [Achievement_Brick_42042_10000.id, Achievement_Brick_42042_10000],
  [Achievement_Brick_42042_50000.id, Achievement_Brick_42042_50000],
  [Achievement_Brick_32553_100.id, Achievement_Brick_32553_100],
  [Achievement_Brick_32553_1000.id, Achievement_Brick_32553_1000],
  [Achievement_Brick_32553_10000.id, Achievement_Brick_32553_10000],
  [Achievement_Brick_32553_50000.id, Achievement_Brick_32553_50000],
  [Achievement_Brick_47298_100.id, Achievement_Brick_47298_100],
  [Achievement_Brick_47298_1000.id, Achievement_Brick_47298_1000],
  [Achievement_Brick_47298_10000.id, Achievement_Brick_47298_10000],
  [Achievement_Brick_47298_50000.id, Achievement_Brick_47298_50000],
  [Achievement_Brick_41671_100.id, Achievement_Brick_41671_100],
  [Achievement_Brick_41671_1000.id, Achievement_Brick_41671_1000],
  [Achievement_Brick_41671_10000.id, Achievement_Brick_41671_10000],
  [Achievement_Brick_41671_50000.id, Achievement_Brick_41671_50000],
  [Achievement_Brick_43558_100.id, Achievement_Brick_43558_100],
  [Achievement_Brick_43558_1000.id, Achievement_Brick_43558_1000],
  [Achievement_Brick_43558_10000.id, Achievement_Brick_43558_10000],
  [Achievement_Brick_43558_50000.id, Achievement_Brick_43558_50000],
  [Achievement_Brick_32506_100.id, Achievement_Brick_32506_100],
  [Achievement_Brick_32506_1000.id, Achievement_Brick_32506_1000],
  [Achievement_Brick_32506_10000.id, Achievement_Brick_32506_10000],
  [Achievement_Brick_32506_50000.id, Achievement_Brick_32506_50000],
  [Achievement_Brick_42760_100.id, Achievement_Brick_42760_100],
  [Achievement_Brick_42760_1000.id, Achievement_Brick_42760_1000],
  [Achievement_Brick_42760_10000.id, Achievement_Brick_42760_10000],
  [Achievement_Brick_42760_50000.id, Achievement_Brick_42760_50000],
  [Achievement_Brick_42074_100.id, Achievement_Brick_42074_100],
  [Achievement_Brick_42074_1000.id, Achievement_Brick_42074_1000],
  [Achievement_Brick_42074_10000.id, Achievement_Brick_42074_10000],
  [Achievement_Brick_42074_50000.id, Achievement_Brick_42074_50000],
  [Achievement_Brick_x346_100.id, Achievement_Brick_x346_100],
  [Achievement_Brick_x346_1000.id, Achievement_Brick_x346_1000],
  [Achievement_Brick_x346_10000.id, Achievement_Brick_x346_10000],
  [Achievement_Brick_x346_50000.id, Achievement_Brick_x346_50000],
  [Achievement_Brick_30173_100.id, Achievement_Brick_30173_100],
  [Achievement_Brick_30173_1000.id, Achievement_Brick_30173_1000],
  [Achievement_Brick_30173_10000.id, Achievement_Brick_30173_10000],
  [Achievement_Brick_30173_50000.id, Achievement_Brick_30173_50000],
  [Achievement_Brick_76764_100.id, Achievement_Brick_76764_100],
  [Achievement_Brick_76764_1000.id, Achievement_Brick_76764_1000],
  [Achievement_Brick_76764_10000.id, Achievement_Brick_76764_10000],
  [Achievement_Brick_76764_50000.id, Achievement_Brick_76764_50000],
  [Achievement_Brick_64644_100.id, Achievement_Brick_64644_100],
  [Achievement_Brick_64644_1000.id, Achievement_Brick_64644_1000],
  [Achievement_Brick_64644_10000.id, Achievement_Brick_64644_10000],
  [Achievement_Brick_64644_50000.id, Achievement_Brick_64644_50000],
  [Achievement_Brick_6246f_100.id, Achievement_Brick_6246f_100],
  [Achievement_Brick_6246f_1000.id, Achievement_Brick_6246f_1000],
  [Achievement_Brick_6246f_10000.id, Achievement_Brick_6246f_10000],
  [Achievement_Brick_6246f_50000.id, Achievement_Brick_6246f_50000],
  [Achievement_Brick_55297_100.id, Achievement_Brick_55297_100],
  [Achievement_Brick_55297_1000.id, Achievement_Brick_55297_1000],
  [Achievement_Brick_55297_10000.id, Achievement_Brick_55297_10000],
  [Achievement_Brick_55297_50000.id, Achievement_Brick_55297_50000],
  [Achievement_Brick_36752a_100.id, Achievement_Brick_36752a_100],
  [Achievement_Brick_36752a_1000.id, Achievement_Brick_36752a_1000],
  [Achievement_Brick_36752a_10000.id, Achievement_Brick_36752a_10000],
  [Achievement_Brick_36752a_50000.id, Achievement_Brick_36752a_50000],
  [Achievement_Brick_30229_100.id, Achievement_Brick_30229_100],
  [Achievement_Brick_30229_1000.id, Achievement_Brick_30229_1000],
  [Achievement_Brick_30229_10000.id, Achievement_Brick_30229_10000],
  [Achievement_Brick_30229_50000.id, Achievement_Brick_30229_50000],
  [Achievement_Brick_30194_100.id, Achievement_Brick_30194_100],
  [Achievement_Brick_30194_1000.id, Achievement_Brick_30194_1000],
  [Achievement_Brick_30194_10000.id, Achievement_Brick_30194_10000],
  [Achievement_Brick_30194_50000.id, Achievement_Brick_30194_50000],
  [Achievement_Brick_64567_100.id, Achievement_Brick_64567_100],
  [Achievement_Brick_64567_1000.id, Achievement_Brick_64567_1000],
  [Achievement_Brick_64567_10000.id, Achievement_Brick_64567_10000],
  [Achievement_Brick_64567_50000.id, Achievement_Brick_64567_50000],
  [Achievement_Brick_30035_100.id, Achievement_Brick_30035_100],
  [Achievement_Brick_30035_1000.id, Achievement_Brick_30035_1000],
  [Achievement_Brick_30035_10000.id, Achievement_Brick_30035_10000],
  [Achievement_Brick_30035_50000.id, Achievement_Brick_30035_50000],
  [Achievement_Brick_4493c01pb02_100.id, Achievement_Brick_4493c01pb02_100],
  [Achievement_Brick_4493c01pb02_1000.id, Achievement_Brick_4493c01pb02_1000],
  [Achievement_Brick_4493c01pb02_10000.id, Achievement_Brick_4493c01pb02_10000],
  [Achievement_Brick_4493c01pb02_50000.id, Achievement_Brick_4493c01pb02_50000],
  [Achievement_Brick_6086_100.id, Achievement_Brick_6086_100],
  [Achievement_Brick_6086_1000.id, Achievement_Brick_6086_1000],
  [Achievement_Brick_6086_10000.id, Achievement_Brick_6086_10000],
  [Achievement_Brick_6086_50000.id, Achievement_Brick_6086_50000],
  [Achievement_Brick_48812_100.id, Achievement_Brick_48812_100],
  [Achievement_Brick_48812_1000.id, Achievement_Brick_48812_1000],
  [Achievement_Brick_48812_10000.id, Achievement_Brick_48812_10000],
  [Achievement_Brick_48812_50000.id, Achievement_Brick_48812_50000],
  [Achievement_Brick_30464_100.id, Achievement_Brick_30464_100],
  [Achievement_Brick_30464_1000.id, Achievement_Brick_30464_1000],
  [Achievement_Brick_30464_10000.id, Achievement_Brick_30464_10000],
  [Achievement_Brick_30464_50000.id, Achievement_Brick_30464_50000],
  [Achievement_Brick_30103_100.id, Achievement_Brick_30103_100],
  [Achievement_Brick_30103_1000.id, Achievement_Brick_30103_1000],
  [Achievement_Brick_30103_10000.id, Achievement_Brick_30103_10000],
  [Achievement_Brick_30103_50000.id, Achievement_Brick_30103_50000],
  [Achievement_Brick_30115_100.id, Achievement_Brick_30115_100],
  [Achievement_Brick_30115_1000.id, Achievement_Brick_30115_1000],
  [Achievement_Brick_30115_10000.id, Achievement_Brick_30115_10000],
  [Achievement_Brick_30115_50000.id, Achievement_Brick_30115_50000],
  [Achievement_Brick_92084_100.id, Achievement_Brick_92084_100],
  [Achievement_Brick_92084_1000.id, Achievement_Brick_92084_1000],
  [Achievement_Brick_92084_10000.id, Achievement_Brick_92084_10000],
  [Achievement_Brick_92084_50000.id, Achievement_Brick_92084_50000],
  [Achievement_Brick_80674_100.id, Achievement_Brick_80674_100],
  [Achievement_Brick_80674_1000.id, Achievement_Brick_80674_1000],
  [Achievement_Brick_80674_10000.id, Achievement_Brick_80674_10000],
  [Achievement_Brick_80674_50000.id, Achievement_Brick_80674_50000],
  [Achievement_Brick_33121_100.id, Achievement_Brick_33121_100],
  [Achievement_Brick_33121_1000.id, Achievement_Brick_33121_1000],
  [Achievement_Brick_33121_10000.id, Achievement_Brick_33121_10000],
  [Achievement_Brick_33121_50000.id, Achievement_Brick_33121_50000],
  [Achievement_Brick_30238_100.id, Achievement_Brick_30238_100],
  [Achievement_Brick_30238_1000.id, Achievement_Brick_30238_1000],
  [Achievement_Brick_30238_10000.id, Achievement_Brick_30238_10000],
  [Achievement_Brick_30238_50000.id, Achievement_Brick_30238_50000],
  [Achievement_Brick_32567_100.id, Achievement_Brick_32567_100],
  [Achievement_Brick_32567_1000.id, Achievement_Brick_32567_1000],
  [Achievement_Brick_32567_10000.id, Achievement_Brick_32567_10000],
  [Achievement_Brick_32567_50000.id, Achievement_Brick_32567_50000],
  [Achievement_Brick_32574_100.id, Achievement_Brick_32574_100],
  [Achievement_Brick_32574_1000.id, Achievement_Brick_32574_1000],
  [Achievement_Brick_32574_10000.id, Achievement_Brick_32574_10000],
  [Achievement_Brick_32574_50000.id, Achievement_Brick_32574_50000],
  [Achievement_Brick_32570_100.id, Achievement_Brick_32570_100],
  [Achievement_Brick_32570_1000.id, Achievement_Brick_32570_1000],
  [Achievement_Brick_32570_10000.id, Achievement_Brick_32570_10000],
  [Achievement_Brick_32570_50000.id, Achievement_Brick_32570_50000],
  [Achievement_Brick_32575_100.id, Achievement_Brick_32575_100],
  [Achievement_Brick_32575_1000.id, Achievement_Brick_32575_1000],
  [Achievement_Brick_32575_10000.id, Achievement_Brick_32575_10000],
  [Achievement_Brick_32575_50000.id, Achievement_Brick_32575_50000],
  [Achievement_Brick_32566_100.id, Achievement_Brick_32566_100],
  [Achievement_Brick_32566_1000.id, Achievement_Brick_32566_1000],
  [Achievement_Brick_32566_10000.id, Achievement_Brick_32566_10000],
  [Achievement_Brick_32566_50000.id, Achievement_Brick_32566_50000],
  [Achievement_Brick_32565_100.id, Achievement_Brick_32565_100],
  [Achievement_Brick_32565_1000.id, Achievement_Brick_32565_1000],
  [Achievement_Brick_32565_10000.id, Achievement_Brick_32565_10000],
  [Achievement_Brick_32565_50000.id, Achievement_Brick_32565_50000],
  [Achievement_Brick_32571_100.id, Achievement_Brick_32571_100],
  [Achievement_Brick_32571_1000.id, Achievement_Brick_32571_1000],
  [Achievement_Brick_32571_10000.id, Achievement_Brick_32571_10000],
  [Achievement_Brick_32571_50000.id, Achievement_Brick_32571_50000],
  [Achievement_Brick_32568_100.id, Achievement_Brick_32568_100],
  [Achievement_Brick_32568_1000.id, Achievement_Brick_32568_1000],
  [Achievement_Brick_32568_10000.id, Achievement_Brick_32568_10000],
  [Achievement_Brick_32568_50000.id, Achievement_Brick_32568_50000],
  [Achievement_Brick_32505_100.id, Achievement_Brick_32505_100],
  [Achievement_Brick_32505_1000.id, Achievement_Brick_32505_1000],
  [Achievement_Brick_32505_10000.id, Achievement_Brick_32505_10000],
  [Achievement_Brick_32505_50000.id, Achievement_Brick_32505_50000],
  [Achievement_Brick_32573_100.id, Achievement_Brick_32573_100],
  [Achievement_Brick_32573_1000.id, Achievement_Brick_32573_1000],
  [Achievement_Brick_32573_10000.id, Achievement_Brick_32573_10000],
  [Achievement_Brick_32573_50000.id, Achievement_Brick_32573_50000],
  [Achievement_Brick_4740_100.id, Achievement_Brick_4740_100],
  [Achievement_Brick_4740_1000.id, Achievement_Brick_4740_1000],
  [Achievement_Brick_4740_10000.id, Achievement_Brick_4740_10000],
  [Achievement_Brick_4740_50000.id, Achievement_Brick_4740_50000],
  [Achievement_Brick_6014b_100.id, Achievement_Brick_6014b_100],
  [Achievement_Brick_6014b_1000.id, Achievement_Brick_6014b_1000],
  [Achievement_Brick_6014b_10000.id, Achievement_Brick_6014b_10000],
  [Achievement_Brick_6014b_50000.id, Achievement_Brick_6014b_50000],
  [Achievement_Brick_3960_100.id, Achievement_Brick_3960_100],
  [Achievement_Brick_3960_1000.id, Achievement_Brick_3960_1000],
  [Achievement_Brick_3960_10000.id, Achievement_Brick_3960_10000],
  [Achievement_Brick_3960_50000.id, Achievement_Brick_3960_50000],
  [Achievement_Brick_50990b_100.id, Achievement_Brick_50990b_100],
  [Achievement_Brick_50990b_1000.id, Achievement_Brick_50990b_1000],
  [Achievement_Brick_50990b_10000.id, Achievement_Brick_50990b_10000],
  [Achievement_Brick_50990b_50000.id, Achievement_Brick_50990b_50000],
  [Achievement_Brick_2489_100.id, Achievement_Brick_2489_100],
  [Achievement_Brick_2489_1000.id, Achievement_Brick_2489_1000],
  [Achievement_Brick_2489_10000.id, Achievement_Brick_2489_10000],
  [Achievement_Brick_2489_50000.id, Achievement_Brick_2489_50000],
  [Achievement_Brick_30139_100.id, Achievement_Brick_30139_100],
  [Achievement_Brick_30139_1000.id, Achievement_Brick_30139_1000],
  [Achievement_Brick_30139_10000.id, Achievement_Brick_30139_10000],
  [Achievement_Brick_30139_50000.id, Achievement_Brick_30139_50000],
  [Achievement_Brick_6222_100.id, Achievement_Brick_6222_100],
  [Achievement_Brick_6222_1000.id, Achievement_Brick_6222_1000],
  [Achievement_Brick_6222_10000.id, Achievement_Brick_6222_10000],
  [Achievement_Brick_6222_50000.id, Achievement_Brick_6222_50000],
  [Achievement_Brick_41531_100.id, Achievement_Brick_41531_100],
  [Achievement_Brick_41531_1000.id, Achievement_Brick_41531_1000],
  [Achievement_Brick_41531_10000.id, Achievement_Brick_41531_10000],
  [Achievement_Brick_41531_50000.id, Achievement_Brick_41531_50000],
  [Achievement_Brick_30360_100.id, Achievement_Brick_30360_100],
  [Achievement_Brick_30360_1000.id, Achievement_Brick_30360_1000],
  [Achievement_Brick_30360_10000.id, Achievement_Brick_30360_10000],
  [Achievement_Brick_30360_50000.id, Achievement_Brick_30360_50000],
  [Achievement_Brick_4285b_100.id, Achievement_Brick_4285b_100],
  [Achievement_Brick_4285b_1000.id, Achievement_Brick_4285b_1000],
  [Achievement_Brick_4285b_10000.id, Achievement_Brick_4285b_10000],
  [Achievement_Brick_4285b_50000.id, Achievement_Brick_4285b_50000],
  [Achievement_Brick_3901_100.id, Achievement_Brick_3901_100],
  [Achievement_Brick_3901_1000.id, Achievement_Brick_3901_1000],
  [Achievement_Brick_3901_10000.id, Achievement_Brick_3901_10000],
  [Achievement_Brick_3901_50000.id, Achievement_Brick_3901_50000],
  [Achievement_Brick_62696_100.id, Achievement_Brick_62696_100],
  [Achievement_Brick_62696_1000.id, Achievement_Brick_62696_1000],
  [Achievement_Brick_62696_10000.id, Achievement_Brick_62696_10000],
  [Achievement_Brick_62696_50000.id, Achievement_Brick_62696_50000],
  [Achievement_Brick_53982_100.id, Achievement_Brick_53982_100],
  [Achievement_Brick_53982_1000.id, Achievement_Brick_53982_1000],
  [Achievement_Brick_53982_10000.id, Achievement_Brick_53982_10000],
  [Achievement_Brick_53982_50000.id, Achievement_Brick_53982_50000],
  [Achievement_Brick_53981_100.id, Achievement_Brick_53981_100],
  [Achievement_Brick_53981_1000.id, Achievement_Brick_53981_1000],
  [Achievement_Brick_53981_10000.id, Achievement_Brick_53981_10000],
  [Achievement_Brick_53981_50000.id, Achievement_Brick_53981_50000],
  [Achievement_Brick_26139_100.id, Achievement_Brick_26139_100],
  [Achievement_Brick_26139_1000.id, Achievement_Brick_26139_1000],
  [Achievement_Brick_26139_10000.id, Achievement_Brick_26139_10000],
  [Achievement_Brick_26139_50000.id, Achievement_Brick_26139_50000],
  [Achievement_Brick_42444_100.id, Achievement_Brick_42444_100],
  [Achievement_Brick_42444_1000.id, Achievement_Brick_42444_1000],
  [Achievement_Brick_42444_10000.id, Achievement_Brick_42444_10000],
  [Achievement_Brick_42444_50000.id, Achievement_Brick_42444_50000],
  [Achievement_Brick_30410_100.id, Achievement_Brick_30410_100],
  [Achievement_Brick_30410_1000.id, Achievement_Brick_30410_1000],
  [Achievement_Brick_30410_10000.id, Achievement_Brick_30410_10000],
  [Achievement_Brick_30410_50000.id, Achievement_Brick_30410_50000],
  [Achievement_Brick_87991_100.id, Achievement_Brick_87991_100],
  [Achievement_Brick_87991_1000.id, Achievement_Brick_87991_1000],
  [Achievement_Brick_87991_10000.id, Achievement_Brick_87991_10000],
  [Achievement_Brick_87991_50000.id, Achievement_Brick_87991_50000],
  [Achievement_Brick_13768_100.id, Achievement_Brick_13768_100],
  [Achievement_Brick_13768_1000.id, Achievement_Brick_13768_1000],
  [Achievement_Brick_13768_10000.id, Achievement_Brick_13768_10000],
  [Achievement_Brick_13768_50000.id, Achievement_Brick_13768_50000],
  [Achievement_Brick_37784_100.id, Achievement_Brick_37784_100],
  [Achievement_Brick_37784_1000.id, Achievement_Brick_37784_1000],
  [Achievement_Brick_37784_10000.id, Achievement_Brick_37784_10000],
  [Achievement_Brick_37784_50000.id, Achievement_Brick_37784_50000],
  [Achievement_Brick_3713_100.id, Achievement_Brick_3713_100],
  [Achievement_Brick_3713_1000.id, Achievement_Brick_3713_1000],
  [Achievement_Brick_3713_10000.id, Achievement_Brick_3713_10000],
  [Achievement_Brick_3713_50000.id, Achievement_Brick_3713_50000],
  [Achievement_Brick_3749_100.id, Achievement_Brick_3749_100],
  [Achievement_Brick_3749_1000.id, Achievement_Brick_3749_1000],
  [Achievement_Brick_3749_10000.id, Achievement_Brick_3749_10000],
  [Achievement_Brick_3749_50000.id, Achievement_Brick_3749_50000],
  [Achievement_Brick_24316_100.id, Achievement_Brick_24316_100],
  [Achievement_Brick_24316_1000.id, Achievement_Brick_24316_1000],
  [Achievement_Brick_24316_10000.id, Achievement_Brick_24316_10000],
  [Achievement_Brick_24316_50000.id, Achievement_Brick_24316_50000],
  [Achievement_Brick_73230_100.id, Achievement_Brick_73230_100],
  [Achievement_Brick_73230_1000.id, Achievement_Brick_73230_1000],
  [Achievement_Brick_73230_10000.id, Achievement_Brick_73230_10000],
  [Achievement_Brick_73230_50000.id, Achievement_Brick_73230_50000],
  [Achievement_Brick_3701_100.id, Achievement_Brick_3701_100],
  [Achievement_Brick_3701_1000.id, Achievement_Brick_3701_1000],
  [Achievement_Brick_3701_10000.id, Achievement_Brick_3701_10000],
  [Achievement_Brick_3701_50000.id, Achievement_Brick_3701_50000],
  [Achievement_Brick_32174_100.id, Achievement_Brick_32174_100],
  [Achievement_Brick_32174_1000.id, Achievement_Brick_32174_1000],
  [Achievement_Brick_32174_10000.id, Achievement_Brick_32174_10000],
  [Achievement_Brick_32174_50000.id, Achievement_Brick_32174_50000],
  [Achievement_Brick_32034_100.id, Achievement_Brick_32034_100],
  [Achievement_Brick_32034_1000.id, Achievement_Brick_32034_1000],
  [Achievement_Brick_32034_10000.id, Achievement_Brick_32034_10000],
  [Achievement_Brick_32034_50000.id, Achievement_Brick_32034_50000],
  [Achievement_Brick_3648_100.id, Achievement_Brick_3648_100],
  [Achievement_Brick_3648_1000.id, Achievement_Brick_3648_1000],
  [Achievement_Brick_3648_10000.id, Achievement_Brick_3648_10000],
  [Achievement_Brick_3648_50000.id, Achievement_Brick_3648_50000],
  [Achievement_Brick_3736_100.id, Achievement_Brick_3736_100],
  [Achievement_Brick_3736_1000.id, Achievement_Brick_3736_1000],
  [Achievement_Brick_3736_10000.id, Achievement_Brick_3736_10000],
  [Achievement_Brick_3736_50000.id, Achievement_Brick_3736_50000],
  [Achievement_Brick_32168_100.id, Achievement_Brick_32168_100],
  [Achievement_Brick_32168_1000.id, Achievement_Brick_32168_1000],
  [Achievement_Brick_32168_10000.id, Achievement_Brick_32168_10000],
  [Achievement_Brick_32168_50000.id, Achievement_Brick_32168_50000],
  [Achievement_Brick_3898_100.id, Achievement_Brick_3898_100],
  [Achievement_Brick_3898_1000.id, Achievement_Brick_3898_1000],
  [Achievement_Brick_3898_10000.id, Achievement_Brick_3898_10000],
  [Achievement_Brick_3898_50000.id, Achievement_Brick_3898_50000],
  [Achievement_Brick_30202_100.id, Achievement_Brick_30202_100],
  [Achievement_Brick_30202_1000.id, Achievement_Brick_30202_1000],
  [Achievement_Brick_30202_10000.id, Achievement_Brick_30202_10000],
  [Achievement_Brick_30202_50000.id, Achievement_Brick_30202_50000],
  [Achievement_Brick_x164_100.id, Achievement_Brick_x164_100],
  [Achievement_Brick_x164_1000.id, Achievement_Brick_x164_1000],
  [Achievement_Brick_x164_10000.id, Achievement_Brick_x164_10000],
  [Achievement_Brick_x164_50000.id, Achievement_Brick_x164_50000],
  [Achievement_Brick_3485_100.id, Achievement_Brick_3485_100],
  [Achievement_Brick_3485_1000.id, Achievement_Brick_3485_1000],
  [Achievement_Brick_3485_10000.id, Achievement_Brick_3485_10000],
  [Achievement_Brick_3485_50000.id, Achievement_Brick_3485_50000],
  [Achievement_Brick_x52_100.id, Achievement_Brick_x52_100],
  [Achievement_Brick_x52_1000.id, Achievement_Brick_x52_1000],
  [Achievement_Brick_x52_10000.id, Achievement_Brick_x52_10000],
  [Achievement_Brick_x52_50000.id, Achievement_Brick_x52_50000],
  [Achievement_Brick_2528_100.id, Achievement_Brick_2528_100],
  [Achievement_Brick_2528_1000.id, Achievement_Brick_2528_1000],
  [Achievement_Brick_2528_10000.id, Achievement_Brick_2528_10000],
  [Achievement_Brick_2528_50000.id, Achievement_Brick_2528_50000],
  [Achievement_Brick_3624_100.id, Achievement_Brick_3624_100],
  [Achievement_Brick_3624_1000.id, Achievement_Brick_3624_1000],
  [Achievement_Brick_3624_10000.id, Achievement_Brick_3624_10000],
  [Achievement_Brick_3624_50000.id, Achievement_Brick_3624_50000],
  [Achievement_Brick_30325_100.id, Achievement_Brick_30325_100],
  [Achievement_Brick_30325_1000.id, Achievement_Brick_30325_1000],
  [Achievement_Brick_30325_10000.id, Achievement_Brick_30325_10000],
  [Achievement_Brick_30325_50000.id, Achievement_Brick_30325_50000],
  [Achievement_Brick_30167_100.id, Achievement_Brick_30167_100],
  [Achievement_Brick_30167_1000.id, Achievement_Brick_30167_1000],
  [Achievement_Brick_30167_10000.id, Achievement_Brick_30167_10000],
  [Achievement_Brick_30167_50000.id, Achievement_Brick_30167_50000],
  [Achievement_Brick_30381_100.id, Achievement_Brick_30381_100],
  [Achievement_Brick_30381_1000.id, Achievement_Brick_30381_1000],
  [Achievement_Brick_30381_10000.id, Achievement_Brick_30381_10000],
  [Achievement_Brick_30381_50000.id, Achievement_Brick_30381_50000],
  // Brick pack achievements
  [Achievement_BrickPack_Sloped_10.id, Achievement_BrickPack_Sloped_10],
  [Achievement_BrickPack_Sloped_50.id, Achievement_BrickPack_Sloped_50],
  [Achievement_BrickPack_Sloped_100.id, Achievement_BrickPack_Sloped_100],
  [Achievement_BrickPack_Minifig_10.id, Achievement_BrickPack_Minifig_10],
  [Achievement_BrickPack_Minifig_50.id, Achievement_BrickPack_Minifig_50],
  [Achievement_BrickPack_Minifig_100.id, Achievement_BrickPack_Minifig_100],
  [Achievement_BrickPack_Bionicles_10.id, Achievement_BrickPack_Bionicles_10],
  [Achievement_BrickPack_Bionicles_50.id, Achievement_BrickPack_Bionicles_50],
  [Achievement_BrickPack_Bionicles_100.id, Achievement_BrickPack_Bionicles_100],
  [Achievement_BrickPack_Animals_10.id, Achievement_BrickPack_Animals_10],
  [Achievement_BrickPack_Animals_50.id, Achievement_BrickPack_Animals_50],
  [Achievement_BrickPack_Animals_100.id, Achievement_BrickPack_Animals_100],
  [Achievement_BrickPack_Minifig2_10.id, Achievement_BrickPack_Minifig2_10],
  [Achievement_BrickPack_Minifig2_50.id, Achievement_BrickPack_Minifig2_50],
  [Achievement_BrickPack_Minifig2_100.id, Achievement_BrickPack_Minifig2_100],
  [Achievement_BrickPack_Bionicles2_10.id, Achievement_BrickPack_Bionicles2_10],
  [Achievement_BrickPack_Bionicles2_50.id, Achievement_BrickPack_Bionicles2_50],
  [
    Achievement_BrickPack_Bionicles2_100.id,
    Achievement_BrickPack_Bionicles2_100,
  ],
  [Achievement_BrickPack_Circular_10.id, Achievement_BrickPack_Circular_10],
  [Achievement_BrickPack_Circular_50.id, Achievement_BrickPack_Circular_50],
  [Achievement_BrickPack_Circular_100.id, Achievement_BrickPack_Circular_100],
  [
    Achievement_BrickPack_MinifigHair_10.id,
    Achievement_BrickPack_MinifigHair_10,
  ],
  [
    Achievement_BrickPack_MinifigHair_50.id,
    Achievement_BrickPack_MinifigHair_50,
  ],
  [
    Achievement_BrickPack_MinifigHair_100.id,
    Achievement_BrickPack_MinifigHair_100,
  ],
  [Achievement_BrickPack_Technic_10.id, Achievement_BrickPack_Technic_10],
  [Achievement_BrickPack_Technic_50.id, Achievement_BrickPack_Technic_50],
  [Achievement_BrickPack_Technic_100.id, Achievement_BrickPack_Technic_100],
  [
    Achievement_BrickPack_MinifigHeadgear_10.id,
    Achievement_BrickPack_MinifigHeadgear_10,
  ],
  [
    Achievement_BrickPack_MinifigHeadgear_50.id,
    Achievement_BrickPack_MinifigHeadgear_50,
  ],
  [
    Achievement_BrickPack_MinifigHeadgear_100.id,
    Achievement_BrickPack_MinifigHeadgear_100,
  ],
  // Set achievements
  [Achievement_Set_6772_1.id, Achievement_Set_6772_1],
  [Achievement_Set_6772_10.id, Achievement_Set_6772_10],
  [Achievement_Set_8534_1.id, Achievement_Set_8534_1],
  [Achievement_Set_8534_10.id, Achievement_Set_8534_10],
  [Achievement_Set_4866_1.id, Achievement_Set_4866_1],
  [Achievement_Set_4866_10.id, Achievement_Set_4866_10],
  [Achievement_Set_4432_1.id, Achievement_Set_4432_1],
  [Achievement_Set_4432_10.id, Achievement_Set_4432_10],
  [Achievement_Set_7146_1.id, Achievement_Set_7146_1],
  [Achievement_Set_7146_10.id, Achievement_Set_7146_10],
  [Achievement_Set_71766_1.id, Achievement_Set_71766_1],
  [Achievement_Set_71766_10.id, Achievement_Set_71766_10],
  [Achievement_Set_21060_1.id, Achievement_Set_21060_1],
  [Achievement_Set_21060_10.id, Achievement_Set_21060_10],
  [Achievement_Set_10305_1.id, Achievement_Set_10305_1],
  [Achievement_Set_10305_10.id, Achievement_Set_10305_10],
  [Achievement_Set_10179_1.id, Achievement_Set_10179_1],
  [Achievement_Set_10179_10.id, Achievement_Set_10179_10],
  [Achievement_Set_10307_1.id, Achievement_Set_10307_1],
  [Achievement_Set_10307_10.id, Achievement_Set_10307_10],
]);
